import React, { Component } from 'react';
import { MoreVert as MoreVertIcon } from '@mui/icons-material';
import Avatar from 'react-avatar';
import Grid from '@mui/material/Grid/Grid';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu/Menu';
import MenuItem from '@mui/material/MenuItem/MenuItem';
import { globalStyles, colors } from '../../theme/index.js';
import Text from '../Text.js';
class SingleLineDisplayCard extends Component {
  state = {
    anchorEl: null
  };
  _handleMenuClick = event => {
    this.setState({
      anchorEl: event.currentTarget
    });
  };
  _handleCloseMenu = () => {
    this.setState({
      anchorEl: null
    });
  };
  _editSegment = () => {
    this._handleCloseMenu();
    this.props.onSelect();
  };
  render() {
    const {
      popUpText,
      id,
      testid
    } = this.props;
    const styles = {
      cardBlock: globalStyles.cardBlock,
      sansShadow: {
        boxShadow: 'none'
      },
      itemBorder: {
        borderBottom: `1px solid ${colors.borderGrey}`
      },
      cardTitle: globalStyles.cardTitle,
      singleLineCard: globalStyles.singleLineCard
    };
    return /*#__PURE__*/React.createElement(Grid, {
      container: true,
      alignItems: "center",
      style: {
        ...styles.cardBlock,
        ...styles.singleLineCard,
        ...styles.sansShadow,
        ...styles.itemBorder
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 2,
      sm: 2,
      md: 1
    }, /*#__PURE__*/React.createElement(Avatar, {
      name: this.props.segment.title,
      size: "40",
      textSizeRatio: 2.2,
      round: false
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 8,
      sm: 9,
      md: 10
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "column",
      alignItems: "flex-start"
    }, /*#__PURE__*/React.createElement("p", {
      id: id || testid,
      style: styles.cardTitle
    }, this.props.segment.title))), this.props.onSelect && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 2,
      sm: 1,
      md: 1,
      style: {
        textAlign: 'center'
      }
    }, /*#__PURE__*/React.createElement(IconButton, {
      "aria-label": "Edit",
      onClick: this._handleMenuClick
    }, /*#__PURE__*/React.createElement(MoreVertIcon, null)), /*#__PURE__*/React.createElement(Menu, {
      anchorEl: this.state.anchorEl,
      open: Boolean(this.state.anchorEl),
      onClose: this._handleCloseMenu,
      disableAutoFocusItem: true
    }, /*#__PURE__*/React.createElement(MenuItem, {
      onClick: this._editSegment
    }, /*#__PURE__*/React.createElement(Text, {
      align: "center",
      color: "inherit",
      medium: true,
      display: "inline"
    }, popUpText)))));
  }
}
export default SingleLineDisplayCard;